var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-56 h-12 px-2 text-sm text-gray-700 transition duration-150 ease-in-out bg-white border rounded-full shadow-md focus:outline-none focus:shadow-solid"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }